import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';
import { Button } from '@/components/atoms/Button';
import styles from './ErrorState.module.scss';
import type { ErrorStateProps } from './ErrorState.types';

/**
 * Estado de error reutilizable para fallos de carga de datos (API/red).
 * Muestra un icono, un título, una descripción y, opcionalmente, un botón
 * de reintentar. Los textos por defecto salen de las claves `errors.*`.
 */
export function ErrorState({
  title,
  description,
  onRetry,
  retryLabel,
  retrying = false,
  icon,
  className,
}: ErrorStateProps) {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.errorState, className)} role="alert">
      <span className={styles.errorState__icon} aria-hidden>
        {icon ?? <AlertTriangle size={28} />}
      </span>
      <h3 className={styles.errorState__title}>{title ?? t('errors.loadTitle')}</h3>
      <p className={styles.errorState__body}>{description ?? t('errors.loadBody')}</p>
      {onRetry && (
        <Button
          variant="outline"
          onClick={onRetry}
          isLoading={retrying}
          className={styles.errorState__retry}
        >
          {retryLabel ?? t('errors.retry')}
        </Button>
      )}
    </div>
  );
}

ErrorState.displayName = 'ErrorState';

export default ErrorState;
